import SectionMap from "./SectionMap";

export default class SectionZoneMap extends SectionMap
{
    constructor()
    {
        super();
    }

    setFields(fields)
    {
        if(!fields['zone_id']) {
            throw new Error("zone id not found");
        }

        this.zoneId = fields['zone_id'];
        this.price = fields['zone_price'];
        this.address = fields['zone_address'];
        this.coords = fields['zone_coords'];
        this.dateDelivery = fields['zone_date_day'];
        this.timeDelivery = fields['zone_date_time'];

        this.flat = fields['zone_flat'];
        this.floor = fields['zone_floor'];
        this.porch = fields['zone_porch'];
        this.code = fields['zone_code'];

    }

    getHtml()
    {
        let address = `<span>${BX.message("LPOST_DELIVERY_ZONE_NOT_SELECTED")}</span>`;

        if(this.address) {
            
            let fullAddress = this.address;
            if(this.flat)
                fullAddress += `, ${BX.message("LPOST_DELIVERY_ZONE_FLAT")} ${this.flat}`;
            if(this.floor)
                fullAddress += `, ${BX.message("LPOST_DELIVERY_ZONE_FLOOR")} ${this.floor}`;
            if(this.porch)
                fullAddress += `, ${BX.message("LPOST_DELIVERY_ZONE_PORCH")} ${this.porch}`;
            if(this.code)
                fullAddress += `, ${BX.message("LPOST_DELIVERY_ZONE_CODE")} ${this.code}`;
            
            address = `
                <span>${fullAddress}</span>
                <span class="delivery-info-block__hint">(${this.coords})</span>
            `;
        }

        let block_for_date_and_time = '';
        if (IS_SHOW_COURIER_DATES && this.dateDelivery && this.timeDelivery) {
            block_for_date_and_time = `<div class="delivery-info-block__row">
                    <div class="delivery-info-block__title">${BX.message("LPOST_DELIVERY_ZONE_TITLE_DATE_DELIVERY")}</div>
                    <div class="delivery-info-block__text">${this.dateDelivery} ${this.timeDelivery?.replace(",", " - ")}</div>
                </div>`;
        }


        let additional_properties = '';
        if (IS_SHOW_ADDITIONAL_PROPERTIES) {
            additional_properties = `
                <input type="hidden" name="LPOST_ZONE_FLAT" value="${this.flat}">
                <input type="hidden" name="LPOST_ZONE_FLOOR" value="${this.floor}">
                <input type="hidden" name="LPOST_ZONE_PORCH" value="${this.porch}">
                <input type="hidden" name="LPOST_ZONE_CODE" value="${this.code}">
            `;
        }

        return `
            <div class="delivery-info-block">
                <div class="delivery-info-block__row">
                    <div class="delivery-info-block__title">${BX.message("LPOST_DELIVERY_ZONE_TITLE_ADDRESS")}</div>
                    <div class="delivery-info-block__text">${address}</div>
                </div>` + block_for_date_and_time +
            `</div>
            <a href="javascript:void(0);" class="adm-btn lpost-pvz__popup-run">${BX.message("LPOST_DELIVERY_ZONE_TITLE_BUTTON")}</a>
            <div>
                <input type="hidden" name="LPOST_ZONE_NUMBER_ID" value="${this.zoneId}"> 
                <input type="hidden" name="LPOST_ZONE_ADDRESS" value="${this.address}">
                <input type="hidden" name="LPOST_ZONE_COORDS" value="${this.coords}">   
                <input type="hidden" name="LPOST_ZONE_DATE_DAY_DELIVERY" value="${this.dateDelivery}"> 
                <input type="hidden" name="LPOST_ZONE_DATE_TIME_DELIVERY" value="${this.timeDelivery}">
                ${additional_properties} 
            </div>
        `;
    }
}


